import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { IconContext } from '@phosphor-icons/react';
import App from './App';
import { GuestAuthProvider } from './contexts/GuestAuthContext';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <IconContext.Provider value={{ weight: 'light' }}>
        <BrowserRouter>
          <GuestAuthProvider>
            <App />
          </GuestAuthProvider>
        </BrowserRouter>
      </IconContext.Provider>
    </QueryClientProvider>
  </React.StrictMode>,
);
